import { create } from "zustand";

// BUG-2370: bridge between customer.js (createCustomer / updateCustomer, plain
// async functions) and the review popup (CustomerReviewHost, mounted once in
// App.js). requestReview resolves true when the cashier confirms, false when they
// go back to edit. With no host mounted (unit tests, a screen without App) it
// resolves true at once, so the save path behaves exactly as before.
const useCustomerReviewStore = create((set, get) => ({
  hostCount: 0,
  phase: null, // "review" | "result"
  review: null,
  result: null,
  _resolve: null,

  registerHost: () => set((s) => ({ hostCount: s.hostCount + 1 })),
  unregisterHost: () => set((s) => ({ hostCount: Math.max(0, s.hostCount - 1) })),

  requestReview: (review) =>
    new Promise((resolve) => {
      if (!get().hostCount || !review) {
        resolve(true);
        return;
      }
      // A second request while one is open answers the first as "go back".
      const pending = get()._resolve;
      if (pending) pending(false);
      set({ phase: "review", review, result: null, _resolve: resolve });
    }),

  answer: (confirmed) => {
    const resolve = get()._resolve;
    set({ phase: null, _resolve: null, ...(confirmed ? {} : { review: null }) });
    if (resolve) resolve(!!confirmed);
  },

  showResult: (result) => {
    if (!get().hostCount) return;
    set({ phase: "result", result });
  },

  close: () => set({ phase: null, review: null, result: null }),
}));

export default useCustomerReviewStore;
